<ng-template let-extraClass="extraClass" #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="loaded ? (cardBeingEditted ? ('Edit Payment Method' | translate) : ('Add Payment Method' | translate)) : ''"
      [noBow]="cameFromAutomaticBooking"
      [canGoBack]="!cameFromAutomaticBooking"
      [customBack]="backPage" />
  }
</ng-template>

<ng-container
*ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>
    <ng-container
    *ngTemplateOutlet="topNav;context:{ extraClass: 'desktop' }" />

    @if (cameFromAutomaticBooking) {
      <tidy-alert>
        <tidy-row class="extra-bottom-padding vertical-align-center">
          <tidy-image [src]="'assets/img/credit-card.svg'" class="title-size" />
          <tidy-text [header]="'How Payment Works'" />
        </tidy-row>
        <tidy-row>
          <tidy-text
            [body]="'TIDY requires a payment method on file to enable auto-schedule. The payment method can be used for your subscription or to pay pros you book. Questions? '" />
          <tidy-text
            [body]="'Contact our Concierge'"
            class="link"
            (action)="goToContactConcierge()" />
          <tidy-text [body]="' or '" />
          <tidy-text
            [body]="'Schedule a Call'"
            class="link"
            (action)="goToScheduleCall()" />
        </tidy-row>
      </tidy-alert>
    }

    @if (cardBeingEditted) {
      <tidy-row [align]="'center'">
        <tidy-text [body]="'Editing card ending in'" /><span>&nbsp;</span>
          <tidy-text [body]="cardBeingEditted?.last4 + ':'" />
        </tidy-row>
      }

      @if (!teamId && !isAddMissingBankInfo) {
        <tidy-card>
          <form [formGroup]="form">
            <tidy-radio-button
              [label]="'Choose a card or bank account'"
              formControlName="cardOrBank"
              [form]="form.controls.cardOrBank"
              [items]="cardOrBankItems"
              (optionChange)="selectCardOrBank($event)" />
          </form>
        </tidy-card>
      }

      @if (teamId) {
        <tidy-card>
          <form [formGroup]="form">
            <tidy-radio-button
              [label]="'Choose a card or add a new card'"
              formControlName="chooseOrAddCard"
              [form]="form.controls.chooseOrAddCard"
              [items]="chooseOrAddCardItems"
              (optionChange)="selectChooseOrAddCard($event)" />
          </form>
        </tidy-card>
      }

      @if (form.value.chooseOrAddCard === 'choose' && teamId) {
        <tidy-card>
          <tidy-row>
            <tidy-select
              [icon]="'assets/svg/card.svg'"
              [multiple]="false"
              [label]="'Payment Method'"
              [items]="paymentMethodsItems"
              [form]="form.controls.paymentMethod"
              formControlName="paymentMethod"
              class="select-custom-input select-custom-input-bigger" />
          </tidy-row>
        </tidy-card>
      }

      @if (isCardSelected) {
        <tidy-card>
          <tidy-row>
            <tidy-text [body]="'Enter Card Information'" />
          </tidy-row>
          @if (!stripeReady) {
            <div class="form-row">
              <ion-skeleton-text animated style="width: 100%; height: 22px; margin: 0;" />
            </div>
          }
          <div class="form-row" [class.stripe-loading]="!stripeReady">
            <form>
              <div id="card-info" #cardInfo></div>
            </form>
          </div>
          @if (showDefaultCardCheckbox) {
            <tidy-row>
              <tidy-checkbox
                [(checked)]="isPrimaryCard"
          [items]="[
            {
              viewValue: 'Make this my primary card', value: true
            }
          ]"
              [initValue]="isPrimaryCard" />
          </tidy-row>
        }
      </tidy-card>
    }

    @if (!isCardSelected && !teamId && form.value.cardOrBank === 'bank') {
      <tidy-card>
        <tidy-row>
          <tidy-text [body]="'Enter Bank Account Information'" />
        </tidy-row>
        <form [formGroup]="form" style="margin-bottom: 1rem">
          <tidy-row class="field-top-padding field-bottom-padding">
            <tidy-input
              formControlName="name"
              [form]="form.controls.name"
              [label]="'Account Holder\'s Full Name'"
              [errorMessage]="'Please enter the account holder\'s full name.'"
              [submitted]="submitted"
              [icon]="'assets/svg/person.svg'" />
          </tidy-row>
        </form>
        <tidy-error-message [text]="errorMessage" />
      </tidy-card>
    }

    @if (!isCardSelected && !teamId && form.value.cardOrBank === 'check') {
      <form [formGroup]="form">
        <tidy-card>
          <tidy-row>
            <tidy-text [header]="'Bank Information'" />
          </tidy-row>
          <tidy-row>
            <tidy-text [body]="'Used for paying vendor invoices by check.'" />
          </tidy-row>
          <tidy-select
            [label]="'Bank Country'"
            formControlName="check_bank_country_code"
            [form]="form.controls.check_bank_country_code"
            [items]="bankCountryItems"
            [icon]="'assets/svg/globe-outline.svg'" />
          <tidy-input
            [label]="'Bank Name'"
            formControlName="check_bank_name"
            [form]="form.controls.check_bank_name"
            [icon]="'assets/svg/business-outline.svg'"
            [submitted]="submitted"
            [errorMessage]="'Please enter the bank name.'" />
          <tidy-input
            [label]="'Account Number'"
            formControlName="check_account_number"
            [form]="form.controls.check_account_number"
            [icon]="'assets/svg/lock-closed-outline.svg'"
            [submitted]="submitted"
            [errorMessage]="'Please enter the account number.'" />
          <tidy-input
            [label]="form.value.check_bank_country_code === 'CA' ? 'Transit Number' : 'Routing Number'"
            formControlName="check_routing_number"
            [form]="form.controls.check_routing_number"
            [icon]="'assets/svg/lock-closed-outline.svg'"
            [submitted]="submitted"
            [errorMessage]="'Please enter the routing/transit number.'" />
        </tidy-card>

        <tidy-card>
          <tidy-row>
            <tidy-text [header]="'Mailing Contact'" />
          </tidy-row>
          <tidy-input
            [label]="'Full Name'"
            formControlName="check_contact_name"
            [form]="form.controls.check_contact_name"
            [icon]="'assets/svg/person-outline.svg'"
            [submitted]="submitted"
            [errorMessage]="'Please enter your name.'" />
          <tidy-input
            [label]="'Address Line 1'"
            formControlName="check_contact_address1"
            [form]="form.controls.check_contact_address1"
            [icon]="'assets/svg/home-outline.svg'"
            [submitted]="submitted"
            [errorMessage]="'Please enter an address.'" />
          <tidy-input
            [label]="'Address Line 2'"
            formControlName="check_contact_address2"
            [form]="form.controls.check_contact_address2" />
          <tidy-input
            [label]="'City'"
            formControlName="check_contact_city"
            [form]="form.controls.check_contact_city"
            [submitted]="submitted"
            [errorMessage]="'Please enter a city.'" />
          <tidy-input
            [label]="'State / Province'"
            formControlName="check_contact_state"
            [form]="form.controls.check_contact_state"
            [submitted]="submitted"
            [errorMessage]="'Please enter a state/province.'" />
          <tidy-input
            [label]="'ZIP / Postal Code'"
            formControlName="check_contact_postal"
            [form]="form.controls.check_contact_postal"
            [submitted]="submitted"
            [errorMessage]="'Please enter a postal code.'" />
          <tidy-input
            [label]="'Country Code'"
            formControlName="check_contact_country"
            [form]="form.controls.check_contact_country"
            [submitted]="submitted"
            [errorMessage]="'Please enter a country.'" />
        </tidy-card>

        <tidy-card>
          <tidy-row>
            <tidy-text [header]="'Signature'" />
          </tidy-row>
          <tidy-row>
            <tidy-text [body]="'Sign in the box below — used on each check.'" />
          </tidy-row>
          <tidy-signature-pad (signatureChange)="onSignatureChange($event)" />
        </tidy-card>
      </form>
    }

    <ng-container>
      <div
        style="display: flex; align-content: center; justify-content: center">
        <re-captcha (resolved)="captchaEvents($event)" />
      </div>
    </ng-container>

    @if (form.value.cardOrBank === 'card') {
      <tidy-row>
        <tidy-button
          [text]="'Save'"
          [action]="boundSubmitCard"
          class="primary" />
      </tidy-row>
    }
    @if (form.value.cardOrBank === 'bank') {
      <tidy-row>
        <tidy-button
          [text]="'Next'"
          [action]="boundNextForBankAccount"
          class="primary" />
      </tidy-row>
    }
    @if (form.value.cardOrBank === 'check') {
      <tidy-row>
        <tidy-button
          [text]="'Save Check Payment Method'"
          [action]="boundSubmitCheck"
          class="primary" />
      </tidy-row>
    }
    <tidy-error-message [text]="errorMessage" />

  </tidy-wrapper>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
